export default {"src":"/_next/static/media/MS.3df61250.svg","height":18,"width":18};